import { render } from "./MembersEditPage.vue?vue&type=template&id=66b67632"
import script from "./MembersEditPage.vue?vue&type=script&lang=js"
export * from "./MembersEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__